import React from 'react';
import { Divider, Typography } from '@mui/material';
import strawberry from '../../../../../images/Agri-info/crops/strawberry_স্ট্রবেরি.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const StrawberryInfo = () => {

    // dynamic title
    useDocumentTitle("স্ট্রবেরি");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                স্ট্রবেরি
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={strawberry} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>ট্রবেরি চাষের এলাকা:</b><br />শীতের দেশে স্ট্রবেরি ভালো হয়। গরমের দেশে গাছ হয় কিন্তু সহজে ফল হতে চায় না। কিন' গবেষকদের প্রচেষ্টায় এদেশে পরীক্ষামূলকভাবে কিছু জাতের চাষ হচ্ছে। দেশের উত্তরাঞ্চলের কিছু জেলায় স্ট্রবেরি ফলানো সম্ভব হয়েছে। বিশেষ করে যেসব জেলায় শীত বেশি পড়ে ও বেশিদিন থাকে সেসব এলাকায় স্ট্রবেরি চাষ করা যেতে পারে। পঞ্চগড়, রংপুর, দিনাজপুর, ঠাকুরগাঁও এমনকি পাবনা, নাটোরেও চাষ করা যায়।</p>
                            <p className="card-text"><b>উপযুক্ত মাটি: </b><br />বেলে দোঁআশ ও মাটিতে প্রচুর জৈব সার প্রয়োগ করে স্ট্রবেরি ফলানো যায়। যেসব জমিতে পানি জমে সেখানে স্ট্রবেরি ফলানো যাবে না।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>চারা তৈরি:</b><br />স্ট্রবেরির চারা এখনও তেমন সহজে পাওয়া যায় না। বিশেষ করে কাঙ্ক্ষিত চারা অবশ্যই বিশ্বস- কোনো নার্সারি থেকে সংগ্রহ করা দরকার। স্ট্রবেরি গাছগুলো গুল্ম ও লতা জাতীয় গাছ বলে গাছের গোড়া থেকে বেশ কিছু লম্বা লম্বা লতা মাটির উপর দিয়ে লতিয়ে যায়। মাটির সংস্পর্শে  লতার গিট  থেকে শিকড় গজায়। শিকড়যুক্ত গিট কেটে নিয়ে মাটিতে পুতে দিলে নতুন চারা তৈরি হবে। অর্ধেক মাটি অর্ধেক গোবর সার মিশিয়ে পলিব্যাগে ভরে একটি করে শিকড়যুক্ত গিটসহ লতা পুঁতে দিতে হয়। এক্ষেত্রে একটি গাছ থেকে ১৮-২০ টি চারা তৈরি করা সম্ভব।</p>
                <p className="card-text"><b>জমি তৈরি: </b><br />জমি ভালভাবে চাষ করে পরিষ্কার পরিচ্ছন্ন করে অন-ত ৩০ সেন্টিমিটার গভীর করে জমি চাষ দিতে হবে। যেহেতু স্ট্রবেরি গাছের শিকড় মাটির উপর দিকে থাকে সেজন্য মাটি ঝুরঝুরা করে নির্ধারিত মাত্রায় সার মাটিতে ভালোভাবে মিশিয়ে দতিে হবে।</p>
                <p className="card-text"><b>চারা রোপণ: </b><br />স্ট্রবেরির চারা মধ্যঅক্টোবর থেকে মধ্যডিসেম্বর পর্যন- রোপণ করা যায়। তবে নভেম্বর মাস স্ট্রবেরি চারা রোপণের জন্য সবচে ভাল। জমি তৈরির পর লাইন থেকে লাইনের দূরত্ব হবে ৫০ সেন্টিমিটার ও প্রতি সারিতে ৩০ সেন্টিমিটার দূরে দূরে স্ট্রবেরির চারা লাগাতে হয়। বৃষ্টি হলে ক্ষেত থেকে অতিরিক্ত পানি সরিয়ে দিতে হবে না হলে গাছ পঁচে যাবে।</p>
                <p className="card-text"><b>সার প্রয়োগ ও সেচ: </b><br />স্ট্রবেরির জন্য দরকার প্রচুর জৈব সার। এজন্য প্রতি একরে ৫০-৬০ কেজি ইউরিয়া সার, ৭০ কেজি টিএসপি সার এবং ৮০ কেজি এমওপি সার প্রয়োগ করতে হবে। এসব সারকে সমান দুভাগে ভাগ করে একভাগ দিতে হয় ফুল আসার একমাস আগে এবং অন্য ভাগ দিতে হবে ফুল ফোটার সময়। ফল ধরা শুরু হলে ২-৩ দিন পর পরই সেচ দিতে হবে।</p>
                <p className="card-text"><b>অন্যান্য যত্ন: </b><br />স্ট্রবেরি গাছে ফুল ধরাতে চাইলে বিশেষ যত্ন নিতে হবে। গাছ লাগানোর পর তার গোড়া থেকে প্রচুর রানার বা কচুর লতির মতো লতা বের হতে থাকে। এগুলো জমি ঢেকে ফেলে। এতে ফলন ভাল হয় না। এসব লতা যাতে কম বের হয় সেজন্য গাছের গোড়ায় খড় বা পলিথিন বিছিয়ে দিতে হয়। পলিথিন সিট ৩০ সেন্টিমিটার পর গোলাকার ছিদ্র করে স্ট্রবেরি গাছের ঝোপকে মুঠো করে ঢুকিয়ে দিতে হয়।  বেশি ফলন ও তাড়াতাড়ি ফল পেতে হরমোন গাছ পাতায় সেপ্র করা যেতে পারে।</p>
                <p className="card-text"><b>ফল সংগ্রহ ও বিক্রি:</b><br />কাঁচা ফল যখন হলদে বা লালচে রঙের হতে শুরু করে তখন বুঝা যাবে ফল পাকা শুরু হয়েছে। ফল পুরো পাকলে লাল হয়ে যায়। তবে বিক্রির জন্য ফল পুরো লাল হওয়ার দরকার নেই। সেক্ষেত্রে ফলগুলো শক্ত থাকা অবস'ায় তুলতে হবে। আর ফল তুলতে হবে বোটা সমেত। পরে কাগজের প্যাকেটে করে বাজারজাত করতে হবে। ফল তোলার পর ১০-১২ দিন পর্যন- ভালো থাকে। গড়ে প্রতি গাছে ১৫০-২০০ গ্রাম ফল ধরে। ফলটি এদেশে নতুন তাই ঝুঁকিও বেশি। তবুও মেধা ও বুদ্ধি প্রয়োগ করে স্ট্রবেরি চাষ একদিন লাভজনক ব্যবসায় পরিণত হবে সে কথা বলা যায়।</p>

            </div>
        </div >

    );
};

export default StrawberryInfo;